<template>
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="14.6569"
			y="0.514709"
			width="4"
			height="20"
			rx="2"
			transform="rotate(45 14.6569 0.514709)"
			fill="white"
		/>
		<rect
			x="17.4853"
			y="14.6569"
			width="4"
			height="20"
			rx="2"
			transform="rotate(135 17.4853 14.6569)"
			fill="white"
		/>
	</svg>
</template>

<script>
export default {
	name: "CancelIcon",
};
</script>
